import { NCGamesToNDG } from "./NCGamesToNDG"

export const blogPosts = [
    {
        slug: "NCGames-to-NDG",
        title: "From NC Games to No Dice Games",
        date: "March 16, 2026",
        excerpt: "The first rendition of my board games review website 'NC Games' looked like a frontend built by a backend developer. After getting my backend RESTful API showing a list of endpoints and getting my head around SQL left joins and all that jazz, the prospect of designing a polished, responsive frontend for a user did not excite me...",
        component: NCGamesToNDG
    }
]
